import {
  TableRow as StyledTableRow,
  TableCell as StyledTableCell,
} from '../../../components/common/Table';

export default function AssesmentDataDetailsRow(props) {
  const { details } = props;
  const detailsEntries = details.map((d, index) => {
    return (
      <StyledTableRow
        key={d.identificationNumber + ' detail row' + index}
        sx={{
          '& > *': {
            borderBottom: 'unset',
          },
        }}
      >
        <StyledTableCell component="th" scope="row">
          {d.identificationNumber}
        </StyledTableCell>
        <StyledTableCell align="center">
          {Number(d.area.toFixed(2))}
        </StyledTableCell>
        <StyledTableCell align="right">
          {Number(d.paymentIncome.toFixed(2))}
        </StyledTableCell>
      </StyledTableRow>
    );
  });
  return <>{detailsEntries}</>;
}
